var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:add-fill",
    clipPath: "url(#clip0_1828_61509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.64706 14.6469C7.64706 14.9277 7.75861 15.197 7.95718 15.3956C8.15575 15.5942 8.42507 15.7057 8.70588 15.7057C8.9867 15.7057 9.25602 15.5942 9.45458 15.3956C9.65315 15.197 9.76471 14.9277 9.76471 14.6469V10.0587H14.3529C14.6338 10.0587 14.9031 9.9471 15.1016 9.74853C15.3002 9.54996 15.4118 9.28065 15.4118 8.99983C15.4118 8.71901 15.3002 8.44969 15.1016 8.25113C14.9031 8.05256 14.6338 7.941 14.3529 7.941H9.76471V3.35277C9.76471 3.07195 9.65315 2.80264 9.45458 2.60407C9.25602 2.4055 8.9867 2.29395 8.70588 2.29395C8.42507 2.29395 8.15575 2.4055 7.95718 2.60407C7.75861 2.80264 7.64706 3.07195 7.64706 3.35277V7.941H3.05882C2.77801 7.941 2.50869 8.05256 2.31012 8.25113C2.11155 8.44969 2 8.71901 2 8.99983C2 9.28065 2.11155 9.54996 2.31012 9.74853C2.50869 9.9471 2.77801 10.0587 3.05882 10.0587H7.64706V14.6469Z",
    fill: "#4F4F4F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1828_61509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.9412,
    height: 16.9412,
    fill: "white",
    transform: "translate(0.235352 0.529297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddd);
export default __webpack_public_path__ + "static/media/addd.cf647f958069aa36d796e05ff43b39a2.svg";
export { ForwardRef as ReactComponent };